import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import ManagerInsuranceCompaniesBatchInvoiceForm from './ManagerInsuranceCompaniesBatchInvoiceForm';
import { CreateInvoiceInsuranceCompanyBatchMutation } from '../../../../../../graphql/graphql';

type InvoiceBatch =
	CreateInvoiceInsuranceCompanyBatchMutation['createInvoiceInsuranceCompanyBatch'];

interface Props extends BaseModalProps {
	batchId: string;
	onSuccess: (invoiceBatch: InvoiceBatch) => void;
}

const ManagerInsuranceCompaniesBatchInvoiceModal = ({
	batchId,
	onSuccess,
	...modalProps
}: Props) => {
	return (
		<BaseModal
			{...modalProps}
			title='component.insuranceCompanyBatch.invoiceForm.title'>
			<ManagerInsuranceCompaniesBatchInvoiceForm
				batchId={batchId}
				onSuccess={onSuccess}
			/>
		</BaseModal>
	);
};

export default ManagerInsuranceCompaniesBatchInvoiceModal;
